import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'

import { SOURCE_STATUS } from '../labels'
import { PAPER, STATUS_COLOR } from '../theme'

interface Props {
  status: string
  size?: number
  label?: string
  /** Marca la fuente que detiene un ciclo: anillo grueso, no otro color. */
  ring?: boolean
  onClick?: () => void
}

/**
 * Indicador de estado discreto.
 *
 * Deliberadamente un punto y no una calcomanía: en la rejilla del calendario
 * hay cientos de celdas, y con etiquetas la vista se vuelve un tablero de
 * colores sin jerarquía. El punto informa sin gritar.
 */
export function StatusDot({ status, size = 9, label, ring, onClick }: Props) {
  const color = STATUS_COLOR[status] ?? '#CFC5B7'
  const unknown = status === 'check_failed' || status === 'unconfigured'

  return (
    <Tooltip title={label ?? SOURCE_STATUS[status] ?? status}>
      <Box
        component="span"
        onClick={onClick}
        sx={{
          display: 'inline-block',
          width: size,
          height: size,
          borderRadius: '50%',
          bgcolor: color,
          flexShrink: 0,
          cursor: onClick ? 'pointer' : 'inherit',
          transition: 'transform 160ms cubic-bezier(0.2,0.8,0.2,1), box-shadow 160ms',
          // Anillo hueco para los estados "no sé"; anillo de papel para lo que bloquea.
          boxShadow: ring
            ? `0 0 0 2px ${PAPER}, 0 0 0 4px ${color}`
            : unknown
              ? `0 0 0 3px ${color}2E`
              : 'none',
          ...(onClick && { '&:hover': { transform: 'scale(1.35)' } }),
        }}
      />
    </Tooltip>
  )
}
